import { Empty } from 'antd'
import Collapse from 'components/UI/Collapse'
import Button from 'components/UI/CoreUIButton'
import SearchInput from 'components/UI/SearchInput'
import Section from 'components/UI/Section'
import Spin from 'components/UI/Spin'
import { API_CATALOG_ACCREDITATIONS } from 'constants/api-v2'
import { useI18n } from 'context/I18nProvider'
import useFilters from 'hooks/filters'
import { useSWRInfiniteScroll } from 'hooks/swr'
import { useLocation } from 'react-router-dom'
import type { Training } from 'shared/types'
import { messageContext } from 'utils/string'
import Card from '../components/Card'
import AccreditationFilters from './components/AccreditationFilters'

const PAGE_SIZE = 30

function Accreditation() {
  const filtersProps = useFilters('catalog-accreditation', true)
  const { values, setValue, url: urlFilters, reset } = filtersProps
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const search = searchParams.get('q')

  const { i18n, i18name } = useI18n()

  const { data, total, size, setSize, isValidating } = useSWRInfiniteScroll(
    `${API_CATALOG_ACCREDITATIONS}?${urlFilters}`,
  )
  const accreditations = (data || []) as Training[]
  const totalItems = total ?? 0
  const lastPage = totalItems > 0 ? Math.ceil(totalItems / PAGE_SIZE) : 0
  const hasNext = totalItems > 0 && size < lastPage
  const next = () => setSize(size + 1)

  const empty = !accreditations?.length

  const filterCollapseItems = [
    {
      key: '1',
      label: (
        <div className="text-gray-600 flex gap-2">
          <span className="uppercase font-semibold">{i18n('label.filters')}</span>
          <span>{i18n('catalog.refine.text')}</span>
        </div>
      ),
      children: <AccreditationFilters values={values} setValue={setValue} />,
      extra: (
        <Button leftIcon="arrow-rotate-left" variant="tertiary" onClick={() => reset()}>
          {i18n('label.reinit')}
        </Button>
      ),
    },
  ]
  return (
    <div className="flex flex-col gap-4">
      <SearchInput
        defaultValue={search ?? ''}
        onChange={txt => setValue('q', txt)}
        debounceTime={300}
        placeholder={i18n('catalog.accreditations.search.placeholder')}
        suffix={`${totalItems} ${i18n('catalog.accreditations.available')}`}
      />
      <Collapse items={filterCollapseItems} />

      <div className="grid grid-cols-4 gap-6 mt-4">
        {!empty &&
          accreditations.map((item: Training) => (
            <Card key={item.id} training={item} path={<div>{`${i18name(item.accreditationDomain)}`}</div>} />
          ))}
        {empty && !isValidating && (
          <Section className="col-span-4">
            <Empty />
          </Section>
        )}
        {empty && isValidating && (
          <div className="col-span-4 flex w-full items-center justify-center">
            <Spin size="middle" />
          </div>
        )}
      </div>
      {!empty && hasNext && (
        <Button onClick={next} className="mt-8 self-center">
          {/* @TODO Port infinite-swr to TS */}
          {/* @ts-ignore */}
          {messageContext(i18n('label.infinite.scroll.button'), { nbPerPage: PAGE_SIZE })}
        </Button>
      )}
    </div>
  )
}

export default Accreditation
